import Model from "../Model";

class Representantinfo extends Model{

    buildUrl ({ param }) {
        return ['employeeview/infobyzoneid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Representantinfo;